module.exports = __webpack_public_path__ + "static/media/handStrength1Right.c35039fa.png";